var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39256 0.206871C3.72905 -0.0689568 4.27095 -0.0689569 4.60744 0.20687L7.7422 2.77652C8.2905 3.22598 7.90621 4 7.13476 4H0.865241C0.0937889 4 -0.290499 3.22598 0.257805 2.77652L3.39256 0.206871Z",
    fill: "#FFCA28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39256 5.20687C3.72905 4.93104 4.27095 4.93104 4.60744 5.20687L7.7422 7.77652C8.2905 8.22598 7.90621 9 7.13476 9H0.865241C0.0937889 9 -0.290499 8.22598 0.257805 7.77652L3.39256 5.20687Z",
    fill: "#FFD54F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39256 10.2069C3.72905 9.93104 4.27095 9.93104 4.60744 10.2069L7.7422 12.7765C8.2905 13.226 7.90621 14 7.13476 14H0.865241C0.0937889 14 -0.290499 13.226 0.257805 12.7765L3.39256 10.2069Z",
    fill: "#FFE082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon_up.98154c680b194286f045fb026278aff8.svg";
export { ForwardRef as ReactComponent };